import { AxiosRequestConfig } from "axios";
import {
  IFCFileApi,
  OrganisationTypesApi,
  OrganisationsApi,
  BuildingsApi,
  UserBuildingsApi,
  BuildingInviteesApi,
  OrganisationAccessRequestsApi,
  UserOrganisationsApi,
  OrganisationDomainsApi,
  LocationsApi,
  UserApi,
  RepositoriesApi,
  InventoryMappingEditorApi,
  InventoryFileApi,
  CategoriesApi,
  DGNBApi,
  SummaryApi,
  SearchApi,
  InventoryEPDsApi,
  ReportBuildingsApi,
  APIKeyApi,
  InventoryProductsApi,
  DatasetCheckerApi,
  ProductEditorApi,
  DetailReportTileApi,
  ComponentsApi,
  OperationalEnergyApi,
  MappingEditorObjectsApi,
  MappingEditorDynamicColumnsApi,
  DynamicMappingEditorApi,
  FileOperationsApi,
  ObjectOperationsApi,
  DashboardApi,
  CalculationsApi,
  RetoolWorkflowsApi,
  Materials2050Api,
  ProcessingRulesApi,
  FileUploadApi,
  EPDInsightsApi,
  ProductPropertyConfigurationApi,
  ComponentInsightsApi,
  BuildingProductEditorApi,
  ManufacturerApi,
  MaterialApi,
  ProductSearchApi,
  ProductsAndComponentsApi,
  InventoryApi, ExportsApi,
  MatchSnapshotsApi,
  LCCApi,
  PropertyBrowserApi,
  LicensesApi,
} from "./generated/index";

export * from "./generated/index";

export const BASE_PATH =
  localStorage.getItem("api") || import.meta.env.VITE_API_BASE_URL;

export const userApi = new UserApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
});

export const repositoriesApi = new RepositoriesApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
});

export const ifcApi = new IFCFileApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
});

export const organisationsTypesApi = new OrganisationTypesApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
});

export const organisationsApi = new OrganisationsApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
});

export const buildingsApi = new BuildingsApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
});

export const licensesApi = new LicensesApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
});

export const buildinginviteesApi = new BuildingInviteesApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
});

export const userBuildingApi = new UserBuildingsApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
});

export const organisationAccessRequestApi = new OrganisationAccessRequestsApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
});

export const userOrganisationsApi = new UserOrganisationsApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
});

export const organisationDomainsApi = new OrganisationDomainsApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
});

export const locationsApi = new LocationsApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
});

export const inventoryMappingEditorAPI = new InventoryMappingEditorApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
});

export const inventoryFileAPI = new InventoryFileApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
});

export const categoriesAPI = new CategoriesApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
});

export const dgnbApi = new DGNBApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
});

export const summaryAPI = new SummaryApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
});

export const searchAPI = new SearchApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
});

export const reportBuildingApi = new ReportBuildingsApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
});



export const apiKey = new APIKeyApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
});

export const inventoryProductsApi = new InventoryProductsApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
});

export const datasetCheckerApi = new DatasetCheckerApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
});

export const detailReportTileApi = new DetailReportTileApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
});

export const componentsApi = new ComponentsApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
});

export const operationalEnergyApi = new OperationalEnergyApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
})

export const mappingEditorDynamicColumnsFp = () => {
  const auth0_token = getLocalAuthToken();
  const token =  `Bearer ${auth0_token}`;
  const lang = localStorage.getItem('lang') || 'de';
  return new MappingEditorDynamicColumnsApi({
    basePath: BASE_PATH,
    isJsonMime: () => true,
    baseOptions: {
      headers: {
        'Authorization': token,
        'Accept-Language': lang
      }
    }
  })};

export const mappingEditorObjectsApi = new MappingEditorObjectsApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
})

export const dynamicMappingEditorFp = () => {
  const auth0_token = getLocalAuthToken();
  const token =  `Bearer ${auth0_token}`;
  const lang = localStorage.getItem('lang') || 'de';
  return new DynamicMappingEditorApi({
    basePath: BASE_PATH,
    isJsonMime: () => true,
    baseOptions: {
      headers: {
        'Authorization': token,
        'Accept-Language': lang
      }
    }
  })};

export const fileOperationsApi = new FileOperationsApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
})

export const objectOperationsApi = new ObjectOperationsApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
})

export const buildingDashboardApi = new DashboardApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
});

export const calculationsApi = new CalculationsApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
})

export const matchSnapshotsApi = new MatchSnapshotsApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
})

export const retoolWorkflowsApi = new RetoolWorkflowsApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
})

export function getLocalAuthToken() {
  const headerKey = "current_user_metadata";
  const localKeys = Object.keys(localStorage).filter((key) =>
    key.includes(headerKey)
  );

  if (localKeys.length > 0) {
    const metadata = JSON.parse(localStorage.getItem(localKeys[0]) || "");
    const token =  metadata?.body.id_token;
    if (token) {
       return token
    }
  }
  return undefined;
}

export function getLocalAuthHeader() {
  let authHeader: AxiosRequestConfig | undefined;
  const token = getLocalAuthToken();
  if (token) {
    authHeader = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
  }
  return authHeader;
}

export const materials2050ApiFp = () => {
  const auth0_token = getLocalAuthToken();
  const token =  `Bearer ${auth0_token}`;
  const lang = localStorage.getItem('lang') || 'de';
  return new Materials2050Api({
  basePath: BASE_PATH,
  isJsonMime: () => true,
  baseOptions: {
    headers: {
      'Authorization': token,
      'Accept-Language': lang
    }
  }
})};

export const reportExportsApi = () => {
  const auth0_token = getLocalAuthToken();
  const token =  `Bearer ${auth0_token}`;
  const lang = localStorage.getItem('lang') || 'de';
  return new ExportsApi({
    basePath: BASE_PATH,
    isJsonMime: () => true,
    baseOptions: {
      headers: {
        'Authorization': token,
        'Accept-Language': lang
      }
    }
})};

export const epdInsightsApi = () => {
  const auth0_token = getLocalAuthToken();
  const token =  `Bearer ${auth0_token}`;
  const lang = localStorage.getItem('lang') || 'de';
  return new EPDInsightsApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
  baseOptions: {
    headers: {
      'Authorization': token,
      'Accept-Language': lang
    }
  }
})};

export const processingRulesApi = () => {
  const auth0_token = getLocalAuthToken();
  const token =  `Bearer ${auth0_token}`;
  return new ProcessingRulesApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
  baseOptions: {
    headers: {
      'Authorization': token
    }}
})}

export const fileUploadApi = () => {
  const auth0_token = getLocalAuthToken();
  const token =  `Bearer ${auth0_token}`;
  return new FileUploadApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
  baseOptions: {
    headers: {
      'Authorization': token
    }}
})
}

export const productEditorApi = () => {
  const auth0_token = getLocalAuthToken();
  const token =  `Bearer ${auth0_token}`;
  return new ProductEditorApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
  baseOptions: {
    headers: {
      'Authorization': token
    }}
})
}

export const buildingProductEditorApi = () => {
  const auth0_token = getLocalAuthToken();
  const token =  `Bearer ${auth0_token}`;
  return new BuildingProductEditorApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
  baseOptions: {
    headers: {
      'Authorization': token
    }}
})
}

export const productPropertyConfigurationApi = () => {
  const auth0_token = getLocalAuthToken();
  const token =  `Bearer ${auth0_token}`;
  return new ProductPropertyConfigurationApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
  baseOptions: {
    headers: {
      'Authorization': token
    }}
})
}

export const componentInsightsApi = () => {
  const auth0_token = getLocalAuthToken();
  const token =  `Bearer ${auth0_token}`;
return new ComponentInsightsApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
  baseOptions: {
    headers: {
      'Authorization': token
    }}
})
}

export const manufacturerApi = () => {
  const auth0_token = getLocalAuthToken();
  const token =  `Bearer ${auth0_token}`;
return new ManufacturerApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
  baseOptions: {
    headers: {
      'Authorization': token
    }}
})
}

export const materialApi = () => {
  const auth0_token = getLocalAuthToken();
  const token =  `Bearer ${auth0_token}`;
return new MaterialApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
  baseOptions: {
    headers: {
      'Authorization': token
    }}
})
}

export const inventoryEPDsApi = () => {
  const auth0_token = getLocalAuthToken();
  const token =  `Bearer ${auth0_token}`;
return new InventoryEPDsApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
  baseOptions: {
    headers: {
      'Authorization': token
    }}
})
}

export const productSearchApi = () => {
  const auth0_token = getLocalAuthToken();
  const token =  `Bearer ${auth0_token}`;
return new ProductSearchApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
  baseOptions: {
    headers: {
      'Authorization': token
    }}
})
}

export const productsAndComponentsApi = () => {
  const auth0_token = getLocalAuthToken();
  const token =  `Bearer ${auth0_token}`;
return new ProductsAndComponentsApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
  baseOptions: {
    headers: {
      'Authorization': token
    }}
})
}

export const lccApi = new LCCApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
});

export const inventoryAPi = () => {
  const auth0_token = getLocalAuthToken();
  const token =  `Bearer ${auth0_token}`;
return new InventoryApi({
  basePath: BASE_PATH,
  isJsonMime: () => true,
  baseOptions: {
    headers: {
      'Authorization': token
    }}
})
}

export const propertyBrowserApi = () => {
  const auth0_token = getLocalAuthToken();
  const token = `Bearer ${auth0_token}`;
  const lang = localStorage.getItem('lang') || 'de';
  return new PropertyBrowserApi({
    basePath: BASE_PATH,
    isJsonMime: () => true,
    baseOptions: {
      headers: {
        'Authorization': token,
        'Accept-Language': lang,
      },
    },
  });
};
